<template>
    <div>
        <div class="title">
            <h3>Os campos com * são de preenchimento obrigatório</h3>
            <h5>Caso queira, você poderá salvar e continuar depois.</h5>
        </div>
        <div class="formulario">
            <div class="agrupamentoFormulario">
                <div class="categoriaAgrupamentoFormulario">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Situação financeira e patrimonial'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Dados Financeiros'"
                        :SubSessao="'Situação Financeira e Patrimonial'" />
                    <span>
                        As informações a seguir devem ser compatíveis com seus investimentos e a sua capacidade
                        financeira e patrimonial, conforme definido na regulamentação vigente.
                    </span>
                </div>
                <div class="camposAgrupamentoFormulario">
                    <div class="row">
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">Remuneração mensal</label>
                            <input class="field" type="text" v-model="localPF.RemuneracaoMensal" id="RemuneracaoMensal"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('RemuneracaoMensal')"
                                @focus="() => focusIn('RemuneracaoMensal')"
                                @input="event => handleInput(event, 'RemuneracaoMensal')">
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 75%">
                            <label class="label" for="nome">Outros rendimentos</label>
                            <div class="radioDadosFinanceiros">
                                <input type="radio" id="Base anual" value="Base anual" name="BaseOutrosRendimentos"
                                    class="field__radio" v-model="localPF.BaseOutrosRendimentos"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="sim" class="label__radio">
                                    Base anual
                                </label>
                                <input type="radio" id="Base mensal" value="Base mensal" name="BaseOutrosRendimentos"
                                    class="field__radio" v-model="localPF.BaseOutrosRendimentos"
                                    @change="salvarAlteracoesLocalmente" />
                                <label for="nao" class="label__radio">
                                    Base mensal
                                </label>
                                <input class="field" type="text" v-model="localPF.OutrosRendimentos"
                                    id="OutrosRendimentos" @change="salvarAlteracoesLocalmente"
                                    @blur="() => focusOut('OutrosRendimentos')"
                                    @focus="() => focusIn('OutrosRendimentos')"
                                    @input="event => handleInput(event, 'OutrosRendimentos')">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente"
                                v-model="localPF.OutrosRendimentosEspecificacao"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">Bens imóveis*</label>
                            <p class="sub-label" for="nome">(caso não possua, incluir o valor "0")</p>
                            <input class="field" type="text" v-model="localPF.BensImoveis" id="BensImoveis"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('BensImoveis')"
                                @focus="() => focusIn('BensImoveis')"
                                @input="event => handleInput(event, 'BensImoveis')">
                            <p v-if="camposObrigatorios.erroBensImoveis" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente" v-model="localPF.BensImoveisEspecificacao"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 20%">
                            <label class="label" for="nome">Bens móveis*</label>
                            <p class="sub-label" for="nome">(caso não possua, incluir o valor "0")</p>
                            <input class="field" type="text" v-model="localPF.BensMoveis" id="BensMoveis"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('BensMoveis')"
                                @focus="() => focusIn('BensMoveis')" @input="event => handleInput(event, 'BensMoveis')">
                            <p v-if="camposObrigatorios.erroBensMoveis" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Especifique</label>
                            <textarea v-model="localPF.BensMoveisEspecificacao" @change="salvarAlteracoesLocalmente"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field">
                            <label class="label" for="nome">Patrimônio líquido em aplicações financeiras*</label>
                            <p class="sub-label" for="nome">(caso não possua, incluir o valor "0")</p>
                            <input class="field" type="text" v-model="localPF.PatrimonioLiquido" id="PatrimonioLiquido"
                                @change="salvarAlteracoesLocalmente" @blur="() => focusOut('PatrimonioLiquido')"
                                @focus="() => focusIn('PatrimonioLiquido')"
                                @input="event => handleInput(event, 'PatrimonioLiquido')">
                            <p v-if="camposObrigatorios.erroPatrimonioLiquido" class="erro">Campo obrigatório.</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field" style="width: 70%">
                            <label class="label" for="nome">Especifique</label>
                            <textarea @change="salvarAlteracoesLocalmente"
                                v-model="localPF.PatrimonioLiquidoEspecificacao"
                                style="width: 100%; height: 80px; max-height: 120px;" class="field"></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="label__field">
                            <label class="label" for="nome">Patrimônio total estimado</label>
                            <input class="field" type="text" v-model.lazy="localPF.PatrimonioTotal"
                                @change="salvarAlteracoesLocalmente" id="PatrimonioTotal" :disabled="true">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { VMoney } from 'v-money'
import LabelDisclaimer from '../Utilitarios/Disclaimer/LabelDisclaimer.vue'
import { formatCurrency, parseCurrency, handleInput } from '@/utils/formUtils';
export default {
    directives: {
        money: VMoney
    },
    name: 'CadastroPF_DadosFinanceiros',
    props: ['informacoesFinanceiras', 'Edicao'],
    components: { LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
        }),
        formattedPatrimonioTotal() {
            return formatCurrency(this.calculatePatrimonioTotal());
        }
    },
    data() {
        return {
            permitirAvancar: true,
            localPF: this.informacoesFinanceiras,
            opcoesDeMoeda: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                precision: 2
            },
            bensImoveis: 0,
            bensMoveis: 0,
            patrimonioLiquido: 0,
            patrimonioTotal: 0,
            camposObrigatorios: {
                erroBensImoveis: false,
                erroBensMoveis: false,
                erroPatrimonioLiquido: false,
            }
        }
    },
    methods: {
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroBensImoveis: false,
                erroBensMoveis: false,
                erroPatrimonioLiquido: false,
            };
            if (!this.localPF.BensMoveis
                || !this.localPF.BensImoveis
                || !this.localPF.PatrimonioLiquido) {
                if (!this.localPF.BensImoveis) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroBensImoveis = true;
                        nomeDoCampo = 'Bens imóveis';
                    }
                    this.permitirAvancar = false;
                }
                if (!this.localPF.BensMoveis) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroBensMoveis = true;
                        nomeDoCampo = 'Bens móveis';
                    }
                    this.permitirAvancar = false;
                }
                if (!this.localPF.PatrimonioLiquido) {
                    if (submeter && this.permitirAvancar) {
                        this.camposObrigatorios.erroPatrimonioLiquido = true;
                        nomeDoCampo = 'Patrimônio líquido';
                    }
                    this.permitirAvancar = false;
                }
            }
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar.`,
                });
            }
        },
        proximaEtapa() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.$store.commit('SET_ETAPA_CADASTRO', 3);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        salvarInformacoes() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
            }
        },
        salvarAlteracoesLocalmente() {
            this.$store.commit('SET_PF_SALVAR_INFO_FINANCEIRAS', this.localPF);
            this.validarFormulario(false);
        },
        focusOut(fieldName) {
            //if (fieldName === 'BensImoveis' || fieldName === 'BensMoveis' || fieldName === 'PatrimonioLiquido') {
                this.localPF[fieldName] = formatCurrency(this.localPF[fieldName]);
                if (this.localPF.BensImoveis && this.localPF.BensImoveis.trim() !== '') {
                    this.bensImoveis = parseFloat(this.localPF.BensImoveis.replace(/[^\d,]/g, '').replace(',', '.'));
                }
                else {
                    this.bensImoveis = 0;
                }
                if (this.localPF.BensMoveis && this.localPF.BensMoveis.trim() !== '') {
                    this.bensMoveis = parseFloat(this.localPF.BensMoveis.replace(/[^\d,]/g, '').replace(',', '.'));
                }
                else {
                    this.bensMoveis = 0;
                }
                if (this.localPF.PatrimonioLiquido && this.localPF.PatrimonioLiquido.trim() !== '') {
                    this.patrimonioLiquido = parseFloat(this.localPF.PatrimonioLiquido.replace(/[^\d,]/g, '').replace(',', '.'));
                }
                else {
                    this.patrimonioLiquido = 0;
                }
                this.patrimonioTotal = this.bensImoveis + this.bensMoveis + this.patrimonioLiquido;
                this.localPF.PatrimonioTotal = formatCurrency(this.patrimonioTotal.toString());
            //}
        },
        focusIn(fieldName) {
            const value = this.localPF[fieldName];
            this.localPF[fieldName] = parseCurrency(value) ? parseCurrency(value).replace('.', ',') : '';
        },
        handleInput(event, fieldName) {
            const inputValue = event.target.value;
            this.localPF[fieldName] = handleInput(inputValue);
        },
    }
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

// .formulario {
//     width: 100%;
// }
// .agrupamentoFormulario {
//     width: 100%;
//     display: inline-flex;
//     margin-top: 10px;
// }
// .categoriaAgrupamentoFormulario {
//     width: 13%;
//     margin-right: 15px;
//     font-family: 'Inter', sans-serif;
//     /* Fonte Inter */
//     span {
//         font-weight: 400 !important;
//         font-size: 13px;
//         color: #667085;
//     }
// }
// .label__field {
//     padding-right: 30px;
// }
.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .radioDadosFinanceiros {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field {
            width: 25% !important;
        }

        .field__radio {
            margin-top: -2px;
            width: 15px;
            height: 15px;
        }

        .fieldInRadio {
            border-radius: 8px;
            border: 1px solid #D0D5DD;
            padding: 10px 14px;
            background-color: #ffffff;
            width: 55%;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
            width: 10% !important;
        }
    }

    label {
        width: 100%;
    }

    .sub-label {
        width: 100%;
    }
}

// .title {
//     border-bottom: 1px solid #EAECF0;
//     h3 {
//         margin-top: 50px;
//         color: #101828;
//         font-weight: 500;
//         font-family: 'Inter', sans-serif;
//     }
//     h5 {
//         margin-top: 5px;
//         margin-block-start: 0;
//         color: #667085;
//         font-weight: 400;
//         font-family: 'Inter', sans-serif;
//     }
// }</style>